<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    深理工站<br>
站点介绍<br>
深理工站为深圳6号线支线的临时终点站，位于光明区公常路和东莞市黄江镇交界处，沿公常路东西向跨路口布置，站点位置依公常路地势呈东高西低，隶属于新湖街道管辖范围。车站色彩基调以白色为主，为地下二层车站，地下二层为站台层，地下一层为站厅层，站台形式为岛式站台。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	--	--	66号线	6分52秒	8-10分钟<br>
深理工	06:27	23:30	66号线	6分52秒	8-10分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	--	--	66号线	6分52秒	8-10分钟<br>
深理工	06:27	23:30	66号线	6分52秒	8-10分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
光明	--	--	66号线	6分52秒	8-11分钟<br>
深理工	06:27	00:30	66号线	6分52秒	8-11分钟<br><br>
<br>
站点出口信息<br>
A1出入口:<br>
深圳理工大学、深圳市光明区安置房<br><br>
A2出入口:<br>
光明派出所治安报警点<br><br>
C1出入口:<br>
光明科学城、大友钢铁、东莞市黄江镇大坑村、芜下农贸市场<br><br>
C2出入口:<br>
中山大学、漳沅金属制品有限公司<br><br>
公交换乘信息<br><br>
C1出入口:<br>
公交站名： 芜下市场<br>
M356<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxianzhixian",
          title: "6号线支线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>